import { Translation } from '@showclix-shared/CheckoutProcess/components/Translation';

export default Translation;
